export function sortNumbers(a: number, b: number): number {
  return a - b;
}
